import {
  Component, NgModule, Input, Output, EventEmitter, OnInit,
} from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';

import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';

import { UserPanelComponent } from '../user-panel/user-panel.component';
import { AuthService, IUser } from 'src/app/services';

import { ThemeSwitcherComponent } from '../theme-switcher/theme-switcher.component';

@Component({
    selector: 'app-header',
    templateUrl: 'app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
    imports: [
        DxToolbarModule,
        NgIf,
        ThemeSwitcherComponent,
        UserPanelComponent,
    ]
})

export class AppHeaderComponent implements OnInit {
  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title!: string;

  user: IUser | null = { email: '' };

  userMenuItems = [
  {
    text: 'Logout',
    icon: 'runner',
    onClick: () => {
      this.authService.logOut();
    },
  }];

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.getUser().then((e) => (this.user = e.value));
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  };
}


